module.exports = __webpack_public_path__ + "img/reena_thumb.19399edb.jpg";